export default __webpack_public_path__ + "static/media/ltr_doodle_grey.39e94a0e.png";